<div class="confirmationContainer site-created">
  <img class="confirmationContainer__headerIcon" src="/assets/svg/icons/circle_check.svg" />
  <div class="confirmationContainer__infoGreen">
    New Sites Added
  </div>

  <h3 class="confirmationContainer__reasonTitle">
    Following site(s) have been added.
  </h3>
  <p *ngFor="let sourceSite of data?.sourceSites">Source Site: {{ sourceSite }}</p>
  <p *ngFor="let fillSite of data?.fillSites">Receiving Site: {{ fillSite }}</p>
  <div class="confirmationContainer__navigationButtons">
    <button class="cmn-blue-btn" routerLink="/admin/sites" mat-raised-button type="button" (click)="dialogRef.close()">
      Back to Site Management <span class="material-icons btn-arw">keyboard_arrow_right</span>
    </button>
  </div>
</div>
